import React, { Component } from 'react';
import Driver from './driver.jsx';
import InfoBox from './info-box.jsx';
import moment from 'moment';
export default class DriversTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers: props.drivers || null,
      isLoading: !props.drivers,
      url: props.url || null,
      viewJustOneDriver: props.viewJustOneDriver || false,
      viewAllJobs: props.viewAllJobs || false,
      jobs: props.jobs || [],
      setLateDriverMsg:[],
      lateDriverJobIds:[],
      infiniteScroll: props.infiniteScroll || false,
      isDriverDashboardPage: props.isDriverDashboardPage || false,
      noOfOverdueMoves: 0,
      movesOverdueIn24Hours: 0,
      overdueJobs: {},
      overdueJobsIn24hours: {},
      stopRerender: false,
    };
    this.handleLateDrivers = this.handleLateDrivers.bind(this);
    this.saveLateJobIdsOFDriver = this.saveLateJobIdsOFDriver.bind(this);
    // this.handleDriverStatestics = this.handleDriverStatestics.bind(this);
    this.handleAddOrderByInUser = this.handleAddOrderByInUser.bind(this);
    this.handleRerenderTrigger = this.handleRerenderTrigger.bind(this);
  }
  getDrivers() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((response) => {

        if ((this.state.viewJustOneDriver === true) &&
            (this.state.viewAllJobs === true)) {
          this.setState({
            drivers: response,
            isLoading: false
          });
        }
        else {
          this.setState({
            drivers: response,
            isLoading: false
          });
        }
      });
      return response;
    });
  }
  componentDidMount() {
    // [TODO] add realtime stuff
    if (this.state.isLoading === true) {
      this.getDrivers().then(function (drivers) {
        
        if (this.state.isDriverDashboardPage) {
          const prioritisedDrivers = drivers.map((user) => this.handleAddOrderByInUser(user));
          this.setState({ drivers: _.orderBy(prioritisedDrivers,'last_job_scheduled_dropoff_date','asc') });
        }
      }.bind(this));
    }
      this.smoothScrollToHash();
      window.addEventListener('hashchange', this.smoothScrollToHash);
  }

  componentWillUnmount(){
      window.removeEventListener('hashchange', this.smoothScrollToHash);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      drivers: nextProps.drivers
    });
  }
  saveLateJobIdsOFDriver(jobsID){
    
    if(!this.state.lateDriverJobIds.includes(jobsID)){
      var joined = this.state.lateDriverJobIds.concat(jobsID);
      this.setState({ lateDriverJobIds: joined },()=>{
        return fetch('/api/v1/portal/jobs/latedriver/updatejob/'+jobsID, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer '+window.api_token
            ,"Accept": 'application/json'
          },
        }).
        then((responseText) => {
          let response = responseText.json();
        });
      });
    }
  }
  handleLateDrivers(someval,driverID){
    //197-gemini-driver-late-pop-to-be-removed
    return false;
    if(someval !== null){
      if(this.state.setLateDriverMsg.indexOf(someval) == -1){
        this.setState({
          setLateDriverMsg: [...this.state.setLateDriverMsg,someval]
        });
      }
    }
    if(this.state.drivers.length > 0){
      
      let lastDriver = this.state.drivers.slice(-1).pop();
      if(driverID == lastDriver.id){
        
        if(this.state.setLateDriverMsg.length > 0 && !this.state.isDriverDashboardPage){
          let infoModal = $('#infomodal');
          $('#infomodallabel').html('Drivers Lists');
          $('#infomodal .modal-body').html("<div class='alert alert-danger'>"+this.state.setLateDriverMsg+"</div>");
          infoModal.modal();
        }
      }
    }
    return false;
  }

  /* 
  handleDriverStatestics(overdueJobs, overdueJobsIn24hours, driver_id) {
    // Copy the existing state arrays
    const updatedOverdueJobs = { ...this.state.overdueJobs };
    const updatedOverdueJobsIn24hours = { ...this.state.overdueJobsIn24hours };
  
    // Update the specific driver's data
    updatedOverdueJobs[driver_id] = overdueJobs;
    updatedOverdueJobsIn24hours[driver_id] = overdueJobsIn24hours;
  
    // Calculate counts
    let noOfOverdueMoves = 0;
    let movesOverdueIn24Hours = 0;
  
    for (const key in updatedOverdueJobs) {
      if (updatedOverdueJobs.hasOwnProperty(key)) {
        const subArray = updatedOverdueJobs[key];
        noOfOverdueMoves += subArray.length;
      }
    }
  
    for (const key in updatedOverdueJobsIn24hours) {
      if (updatedOverdueJobsIn24hours.hasOwnProperty(key)) {
        const subArray = updatedOverdueJobsIn24hours[key];
        movesOverdueIn24Hours += subArray.length;
      }
    }
  
    // Update the state once with all changes
    this.setState({
      overdueJobs: updatedOverdueJobs,
      overdueJobsIn24hours: updatedOverdueJobsIn24hours,
      noOfOverdueMoves: noOfOverdueMoves,
      movesOverdueIn24Hours: movesOverdueIn24Hours,
    });
  }
   */
  handleAddOrderByInUser(user){
    if (user && user.driver) {
      const lastJobOfDriver = _.last(user.driver.jobs);
      if (!lastJobOfDriver) {
        user['last_job_scheduled_dropoff_date'] = moment().add(-1, 'month').format("YYYY-MM-DD HH:mm:ss");
      } else {
        user['last_job_scheduled_dropoff_date'] = moment(lastJobOfDriver.scheduled_dropoff_date).format("YYYY-MM-DD HH:mm:ss");
      }
    }
    return user;
  }
  handleRerenderTrigger(jobs, driver_id, driver) {
    this.setState((prevState) => {
      const updatedDrivers = prevState.drivers.map((user) => {
        if (user.id === driver_id) {
          user = { ...user, driver: driver };
          return { ...user, driver: { ...user.driver, jobs } };
        }
        return user;
      });
  
      return { drivers: updatedDrivers, stopRerender: false };
    });
    let drivers = this.state.drivers;
    const prioritisedDrivers = drivers.map((user) => this.handleAddOrderByInUser(user));
    this.setState({ drivers: _.orderBy(prioritisedDrivers,'last_job_scheduled_dropoff_date','asc') });
  }
  
  smoothScrollToHash = () => {
    if (this.props.isSchedulePage) {
      const getOffsetTop = function(element) {
        if (!element) return 0;
        return element.offsetTop + getOffsetTop(element.offsetParent);
      };

      const hash = window.location.hash.substring(1);
      if (hash) {
        this.scrollToHashWhenReady(hash, getOffsetTop);
      }
    }
  };


  scrollToHashWhenReady = (hash, getOffsetTop) => {
    const targetElement = document.querySelector('#' + hash);
    if (targetElement) {
      const navBarHeight = 150;
      const offsetTop = getOffsetTop(targetElement) - navBarHeight;
      // console.log(hash, offsetTop);
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    } else {
      // Use MutationObserver to wait for the target element to be available
      const observer = new MutationObserver((mutations, obs) => {
        const targetElement = document.querySelector('#' + hash);
        if (targetElement) {
          const navBarHeight = 150;
          const offsetTop = getOffsetTop(targetElement) - navBarHeight;
          // console.log(hash, offsetTop);
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };


  
  render() {
    let Drivers = [];
    let DriversNewCol = [];
    let DriversNewCol2 = [];
    let viewAllJobs = this.state.viewAllJobs;
    let handleLateDriversFunc = this.handleLateDrivers;
    let saveLateJobIdsOFDriverFunc = this.saveLateJobIdsOFDriver;
    let infiniteScroll = this.state.infiniteScroll;
    let isDriverDashboardPage = this.state.isDriverDashboardPage;
    // let handleDriverStatesticsFunc = this.handleDriverStatestics;
    let handleRerenderTriggerFunc = this.handleRerenderTrigger
    if (this.state.drivers && this.state.drivers.length > 0) {
      this.state.drivers.forEach(function(i,j) {
        if (i && i.driver) {
          if(j < 30 && isDriverDashboardPage){
            DriversNewCol.push(
              <Driver
                key={'driver-' + i.id}
                data={i}
                jobs={i.jobs}
                infiniteScroll={infiniteScroll}
                viewAllJobs={viewAllJobs}
                handleLateDrivers={handleLateDriversFunc}
                saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
                isDriverDashboardPage={isDriverDashboardPage}
                // handleDriverStatestics={handleDriverStatesticsFunc}
                handleRerenderTrigger={handleRerenderTriggerFunc}
              />
            );
	 } else if(j < 60 && isDriverDashboardPage){
            DriversNewCol2.push(
              <Driver
                key={'driver-' + i.id}
                data={i}
                jobs={i.jobs}
                infiniteScroll={infiniteScroll}
                viewAllJobs={viewAllJobs}
                handleLateDrivers={handleLateDriversFunc}
                saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
                isDriverDashboardPage={isDriverDashboardPage}
                // handleDriverStatestics={handleDriverStatesticsFunc}
                handleRerenderTrigger={handleRerenderTriggerFunc}
              />
            );
          } else {
            Drivers.push(
              <Driver
                key={'driver-' + i.id}
                data={i}
                jobs={i.jobs}
                infiniteScroll={infiniteScroll}
                viewAllJobs={viewAllJobs}
                handleLateDrivers={handleLateDriversFunc}
                saveLateJobIdsOFDriver={saveLateJobIdsOFDriverFunc}
                isDriverDashboardPage={isDriverDashboardPage}
                // handleDriverStatestics={handleDriverStatesticsFunc}
                handleRerenderTrigger={handleRerenderTriggerFunc}
              />
            );
          }
          
        }
      });
    }
    return (
      <>
        {/* {this.state.isDriverDashboardPage ? (
          <div className="row"><div className="col-12 col-sm-6 col-md-3">
            <InfoBox label="Number of Overdue Moves"
              icon="fa-hourglass-half"
              number={this.state.noOfOverdueMoves}
              bg="bg-info" />
          </div><div className="col-12 col-sm-6 col-md-3">
              <InfoBox label="Moves Overdue in 24 hours"
                icon="fa-hourglass-end"
                number={this.state.movesOverdueIn24Hours}
                bg="bg-danger" />
            </div></div>) : null} */}

      <div className="drivers-table">
        <div className="tab-content-container main-tab-content-container">
          {
          this.state.isLoading ?
            (<div className="loading-box">
                <span className="add-loading-text">
                    <i className="fa fa-spinner fa-pulse"></i>
                </span>
            </div>) :
              ((this.state.isDriverDashboardPage) ? 
                <div className="row">
		                      <div className="col-4 no-padding">{DriversNewCol}</div>
                <div className="col-4 no-padding">{DriversNewCol2}</div>
                <div className="col-4 no-padding">{Drivers}</div>
              </div> : 
              Drivers
            )
          }
        </div>
      </div>
      </>
    );
  }
}
